export enum VariationTemplates {
  UNIFIED,
  SPLIT,
  NEW_BRAND
}

export enum ButtonVariations {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  ICON = 'icon',
  SUCCESS = 'success',
  DANGER = 'danger',
  DANGER_SECONDARY = 'danger-secondary',
  LIST_ITEM = 'list-item',
  BANNER = 'banner',
  BANNER_SECONDARY = 'banner-secondary'
}

export interface VariantBackgroundImage {
  image: string;
  horizontalPosition: string;
  verticalPosition: string;
}

export interface VariantBackgroundColor {
  color: string;
}

export interface SplashVariant {
  type: string;
  version: number;
  background: {
    image: string;
    horizontalPosition?: string;
    verticalPosition?: string;
    width?: string;
    height?: string;
  };
  image?: string;
  title?: string;
  subtitle?: string;
  textColor?: string;
  align?: 'center' | 'left';
  button?: {
    text: string;
    url: string;
    variation?: ButtonVariations;
    fullWidth?: boolean;
  };
  metadata?: {
    title?: string;
    description?: string;
  };
}

export interface Variant {
  type: string;
  version?: number;
  background: VariantBackgroundColor | VariantBackgroundImage | React.ReactNode;
  title: string;
  preferredLoginTitle?: string;
  subtitle: string;
  preferredLoginSubtitle?: string;
  image?: string;
  metadata?: {
    title?: string;
    description?: string;
  };
  splash?: SplashVariant;
}
